import React from "react";
import TryThisOut from "../pages/tryNow/TryThisOut";

function PancardOCR({ currentProduct }) {
  return (
    <>
      <TryThisOut currentProduct={currentProduct} />
    </>
  );
}

export default PancardOCR;
